import React from 'react';
import { FadeIn } from './FadeIn';
export function UniqueMechanism() {
  return <section className="bg-cream py-6 px-4 md:px-8" data-id="element-172">
      <div className="max-w-2xl mx-auto" data-id="element-173">
        <FadeIn data-id="element-174">
          <div className="bg-white rounded-xl p-4 md:p-6 shadow-md border-t-4 border-forest" data-id="element-175">
            <h2 className="text-xl md:text-2xl font-bold text-forest mb-3 text-center" data-id="element-176">
              The "10-Minute Micro-Prep" Protocol
            </h2>

            <div className="space-y-3 text-sm md:text-base text-charcoal leading-relaxed" data-id="element-177">
              <p data-id="element-178">
                Instead of "dieting," we use{' '}
                <strong className="text-forest" data-id="element-179">
                  High-Density Anti-Inflammatory Loading (HDAIL)
                </strong>
                .
              </p>
              <p data-id="element-180">
                We flood your tissues with specific, "No-Chop" ingredients that
                act as nature's ibuprofen—thinning the inflammatory fluid around
                your joints and lubricating your hinges from the inside out.
              </p>
              <p className="bg-cream-dark p-3 rounded-lg font-medium text-center italic mt-2" data-id="element-181">
                Every meal is designed to be assembled in under 10 minutes to
                protect your hands and your time.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}